class TC_PlayerBitrate {
    constructor (playerInstance) {
        this.player = playerInstance;
    }

    eventBitrate (e) {
        e.stopPropagation();

        if (this.player.user.isVip) {
            if (this.player.UI.popups.bitrate.hasClass('is-hidden')) {
                this.player.UI.popups.bitrate.removeClass('is-hidden');
                $(document).trigger('playerMakeOpaque');
            } else {
                this.hidePopup();
            }
        } else {
            this.player.systemMessages.showMessage('vipBitrate');
        }
    }

    initBitrateEvents () {
        for (let i = 0; i < this.player.UI.buttons.bitrateItems.length; i++) {
            let item = this.player.UI.buttons.bitrateItems.eq(i);

            item.on('click', () => {
                let value = parseInt(item.attr('data-value'), 10);
                item.parent().find('span.cr-player-bitrate-in').removeClass('is-active');
                item.find('span.cr-player-bitrate-in').addClass('is-active');
                this.bitrateAudio(value);
            });
        }

        $('.cr-player-bitrate-in.is-active').removeClass('is-active');
        $('.cr-player-bitrate-item[data-value="' + parseInt(this.player.bitrateMode, 10) + '"]').find('.cr-player-bitrate-in').addClass('is-active');
    }

    bitrateAudio (newValue) {
        this.player.stoppedChannelsBitrate = parseInt(this.player.bitrateMode, 10);
        this.player.bitrateMode = parseInt(newValue, 10);
        this.player.loadChannel(this.player.currentChannel.id, true);
        this.player.stoppedChannelsBitrate = null;
        window.TC_debouncedPlayerConfigSave(this.player);
    }

    toggleBitrateUI () {
        if (this.player.currentChannelHasChapters()) {
            this.player.UI.popups.bitrate.addClass('is-hidden');
            this.player.UI.buttons.bitrate.addClass('is-hidden');
        } else {
            this.player.UI.buttons.bitrate.removeClass('is-hidden');
        }
    }

    hidePopup () {
        this.player.UI.popups.bitrate.addClass('is-hidden');
    }

    showPopup () {
        this.player.UI.popups.bitrate.removeClass('is-hidden');
    }
}
